import { render, staticRenderFns } from "./StudentHonorTitle.vue?vue&type=template&id=27ba8d36&scoped=true"
import script from "./StudentHonorTitle.vue?vue&type=script&lang=js"
export * from "./StudentHonorTitle.vue?vue&type=script&lang=js"
import style0 from "./StudentHonorTitle.vue?vue&type=style&index=0&id=27ba8d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba8d36",
  null
  
)

export default component.exports